import React, {Component, Fragment} from 'react';
import ImageDetail from './imageDetail';

class ImagePosition extends Component{
    constructor(props){
        super();
    }
    render(){
        return(
            <Fragment>
                <div style={{backgroundColor:'#f4f6f9'}}>
                    <ImageDetail />
                </div>
            </Fragment>
        )
    }
}

export default ImagePosition;